import { render, staticRenderFns } from "./formDetail.vue?vue&type=template&id=33d08b3a"
import script from "./formDetail.vue?vue&type=script&lang=js"
export * from "./formDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports